import { render } from "./AddCampaign.vue?vue&type=template&id=5dc9945e&ts=true"
import script from "./AddCampaign.vue?vue&type=script&lang=ts"
export * from "./AddCampaign.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-distribution-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__